const header = () => {
  const mainVisual = document.querySelector('.main-visual-section')
  const productThumbnail = document.querySelector('.product-slider')
  const pageVisual = document.querySelector('.page-visual')
  const body = document.querySelector('body')

  /**
   * ヘッダーの色変更のクラスを切り替える
   * @param element {HTMLElement} - ヘッダーの色変更の要素
   */
  const toggleHeaderColorChangeClass = (element) => {
    if (window.scrollY >= element.clientHeight) {
      body.classList.add('is-header-color-change')
    } else {
      body.classList.remove('is-header-color-change')
    }
  }

  /**
   * TOPメインビジュアル向け対応
   */
  if (mainVisual) {
    window.addEventListener('scroll', () => toggleHeaderColorChangeClass(mainVisual))
  }

  /**
   * 商品詳細向け対応
   */
  if (productThumbnail) {
    const toggleHeaderColorChangeClassScroll = () => toggleHeaderColorChangeClass(productThumbnail)
    /**
     * リサイズ時にヘッダーの色変更のイベントを切り替える
     */
    const handleResize = () => {
      const mediaQuery = window.matchMedia('(min-width: 768px)')
      if (mediaQuery.matches) {
        body.classList.add('is-header-color-change')
        window.removeEventListener('scroll', toggleHeaderColorChangeClassScroll)
      } else {
        body.classList.remove('is-header-color-change')
        window.addEventListener('scroll', toggleHeaderColorChangeClassScroll)
      }
    }

    let tempWidth = window.innerWidth
    window.addEventListener('resize', () => {
      const windowWidth = window.innerWidth
      if (tempWidth === windowWidth) return
      handleResize()
      tempWidth = windowWidth
    })

    handleResize()
  }

  /**
   * 固定ページ向け対応
   */
  if (pageVisual) {
    window.addEventListener('scroll', () => toggleHeaderColorChangeClass(pageVisual))
  }
}

const headerScrollHidden = () => {
  if (document.querySelector('.product-section')) {
    const body = document.querySelector('body')
    let scrollPoint = 0
    let lastPoint = 0

    window.addEventListener('scroll', () => {
      scrollPoint = window.scrollY

      if (scrollPoint > lastPoint) {
        body.classList.add('is-fixed-hide')
      } else {
        body.classList.remove('is-fixed-hide')
      }

      lastPoint = scrollPoint < 0 ? 0 : scrollPoint
    })
  }
}

const headerSetting = () => {
  header()
  headerScrollHidden()
}

export { headerSetting }
